import React, {useContext} from "react" ;

import AppSidebarMenuItem from "../../Common/Sidebar/AppSidebarMenuItem";
import AppSidebarGroup from "../../Common/Sidebar/AppSidebarGroup";
import LetterboxAppQuickMenu from "./LetterboxAppQuickMenu";
import {Route, Switch, useLocation} from "react-router-dom";
import LetterboxSubmenu from "./LetterboxSubmenu";
import CalendarSubmenu from "./CalendarSubmenu";
import {
    getLetterboxRouterLink, PATH_HOME_ROOT,
    PATH_LETTERBOX_CALENDAR,
    PATH_LETTERBOX_LETTERBOX,
    PATH_LETTERBOX_ROOT
} from "root/Wieldy/routePaths";

import { LetterBoxFilter } from "root/DataFunctions/Constants";

import ScrollRails from "root/Wieldy/ApplicationModules/Common/Body/ScrollRails";
import AppSidebarHeader from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarHeader";
import {ApplicationTypes, doesUserHaveApplication} from "root/DataFunctions/PageContentRoles";
import GlobalContext from "root/contexts/GlobalContext";

const LetterboxAppSidebar= (props) =>
{
    const { pathname }  = useLocation();

    // Note this will change if you add any more items to the AppSidebarGroup below
    const default_menu = pathname.includes('/letterbox/calendar') ? 'calendar' : 'letterbox' ;

    return (
        <div className="dt-module__sidebar">

            <AppSidebarHeader iconName={props.iconName} title={props.title}>
                <LetterboxAppQuickMenu />
            </AppSidebarHeader>

            { /* Sidebar Menu */}
            <div className="dt-module__sidebar-content ps-custom-scrollbar ps" style={{height: props.height}}>

                <ul className="dt-module-side-nav">

                    { /* Menu Item */}
                    <AppSidebarGroup title='View' default={default_menu}>
                        <AppSidebarMenuItem link={getLetterboxRouterLink('letterbox?type=' + LetterBoxFilter.UNAPPROVED )} title='Letterbox' iconName='icon-email' name='letterbox' />
                        {/*<AppSidebarMenuItem link={PATH_LETTERBOX_CALENDAR} title='Calendar' name='calendar' iconName='icon-calendar'/>*/}
                    </AppSidebarGroup>

                    <Switch>
                        <Route path={PATH_LETTERBOX_LETTERBOX} render={(props) => <LetterboxSubmenu {...props}/>}/>
                        <Route path={PATH_LETTERBOX_CALENDAR} render={(props) => <CalendarSubmenu {...props}/>}/>
                        <Route exact path={PATH_LETTERBOX_ROOT} render={(props) => <LetterboxSubmenu {...props}/>}/>
                        <Route exact path={PATH_HOME_ROOT} render={(props) => <LetterboxSubmenu {...props}/>}/>
                    </Switch>

                </ul>

                <ScrollRails />
            </div>

        </div>
    ) ;
}

export default LetterboxAppSidebar;
